import React from 'react'
import styled from 'styled-components'

import Form from 'containers/Form'

import ArrowIcon from './images/ic-arrow.svg'
import Infoicon from 'components/Svg/informacao.svg'

import Logic from './logic'

import Section from 'components/Section'
import RadioGroup from 'components/RadioGroup'
import ButtonConfirm from 'components/ButtonConfirm'
import Toltip from 'components/Toltip'
import Loading from 'components/Loading'
import Select from 'components/Select'
import Tip from 'components/Tip'
import FixedWrapper from 'components/FixedWrapper'

import {
  BOOLEAN_CHOICES,
  GAS_OFFER_TYPE,
  ELECTRICITY_OFFER_TYPE,
  GAS_AND_ELECTRICITY_OFFER_TYPE,
  isSimple,
  isEnterprise,
} from 'config'

import { mapObjectToarray, generateMediaUrl, pickOrNot } from 'utils'

import { Messages } from 'validations'

const MAX_LIST_ITEMS = 12

/* eslint-disable camelcase */
const paymentMethods = [
  {
    text: 'Multibanco / CTT / Payshop',
    value: 'atm_ctt',
  },
  {
    text: 'Débito Direto',
    value: 'direct_debit',
  },
]

@Logic
export default class Faturation extends Form {
  nextText = `PRÓXIMO passo`
  prevText = `Passo Anterior`

  componentWillMount() {
    if (isSimple) {
      this.nextText = `Simular`
    }
  }

  componentDidMount() {
    // Scrols to top on component mount
    const element = document.getElementById('anchor')

    window.scroll({
      top: element.getBoundingClientRect().top,
    })
  }

  componentDidUpdate(oldProps) {
    if (oldProps.loading && !this.props.loading) {
      const element = document.getElementById('anchor')

      window.scroll({
        top: element.getBoundingClientRect().top,
      })
    }

    this.sendHeight()
    window.addEventListener('resize', this.sendHeight)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.sendHeight)
  }

  sendHeight = () => {
    const height = document.body.scrollHeight
    window.parent.postMessage({ type: 'setHeight', height }, '*')
  }

  next = () => {
    const { valid, invalid } = this.isFormValid()
    const { setFinished, setInvalid } = this.actions
    const { router, values } = this.props
    const { has_consumes } = values
    if (valid) {
      setFinished({ faturationFinished: true })
      setInvalid({})
      window.parent.postMessage({ type: 'scrollToTop' }, '*')

      if (isSimple && has_consumes !== true) {
        router.push('/resultados')
      } else {
        router.push('/consumos')
      }
    } else {
      setFinished({ faturationFinished: false })
      setInvalid(invalid)

      let gasEntityInvalid = pickOrNot(invalid, ['gas_entity'])
      let electricityEntityInvalid = pickOrNot(invalid, ['electricity_entity'])

      if (electricityEntityInvalid) {
        let el = document.getElementById('comerel')
        let el2 = document.getElementById('comerelg')
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' })
        }

        if (el2) {
          el2.scrollIntoView({ behavior: 'smooth' })
        }

        return false
      }

      if (gasEntityInvalid) {
        let el = document.getElementById('comerg')
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' })
        }

        return false
      }
    }
  }

  prev = () => {
    const { router } = this.props

    // If current simulador is empresarial prev must be the profile
    if (isEnterprise) {
      router.push('/')
    } else {
      router.push('/habitacao')
    }

    window.parent.postMessage({ type: 'scrollToTop' }, '*')
  }

  renderInvalidMessage = (invalid, field, name) => {
    if (invalid) {
      if (invalid[field]) {
        const Message = Messages[invalid[field]]
        if (Message) {
          return <Error>{Message(name)}</Error>
        }
      }
    }

    return null
  }

  pickTranslations(translations) {
    const {
      GAS_SCALE,
      GAS_SCALE_ENTERPRISE,
      BILLING_TYPE,
      ELECTRONIC_BILL,
      JOINT_BILLING,
      ADDITIONAL_SERVICES,
      ELECTRICITY_SUPPLIER,
      ELECTRICITY_RATE,
      GAS_SUPPLIER,
      ENTERPRISE_BILLING_TYPE,
      ENTERPRISE_ELECTRONIC_BILL,
      ENTERPRISE_JOINT_BILLING,
      ENTERPRISE_ADDITIONAL_SERVICES,
      ENTERPRISE_ELECTRICITY_SUPPLIER,
      ENTERRPISE_ELECTRICITY_RATE,
      ENTERPRISE_GAS_SUPPLIER,
    } = translations || {}

    if (isEnterprise) {
      return {
        BILLING_TYPE: ENTERPRISE_BILLING_TYPE,
        ELECTRONIC_BILL: ENTERPRISE_ELECTRONIC_BILL,
        JOINT_BILLING: ENTERPRISE_JOINT_BILLING,
        ADDITIONAL_SERVICES: ENTERPRISE_ADDITIONAL_SERVICES,
        ELECTRICITY_SUPPLIER: ENTERPRISE_ELECTRICITY_SUPPLIER,
        ELECTRICITY_RATE: ENTERRPISE_ELECTRICITY_RATE,
        GAS_SUPPLIER: ENTERPRISE_GAS_SUPPLIER,
        GAS_SCALE: GAS_SCALE_ENTERPRISE,
      }
    } else {
      return {
        BILLING_TYPE,
        ELECTRONIC_BILL,
        JOINT_BILLING,
        ADDITIONAL_SERVICES,
        ELECTRICITY_SUPPLIER,
        ELECTRICITY_RATE,
        GAS_SUPPLIER,
        GAS_SCALE,
      }
    }
  }

  /**
   * Logic to be applied to values based on
   * consumptionDisaggregation value
   */
  consumptionDisaggregationLogic = (values) => {
    const { consumptionDisaggregation } = this.props.values
    let { simples, cheias } = values

    switch (consumptionDisaggregation) {
      // Fill all fields with simples value
      case 's':
        if (simples) {
          values.svazio = simples
          values.cheias = simples
          values.ponta = simples
        }
        return values

      case 'vf':
        if (simples) {
          values.svazio = simples
        }

        if (cheias) {
          values.ponta = cheias
        }

        return values
      case 'vcp':
        if (simples) {
          values.svazio = simples
        }
        return values
      case 'vscp':
        return values
      default:
        return values
    }
  }

  /**
   * Sets the value of the electricity element by index
   */
  setTableElectricityValues = (values, index) => {
    const { setValues } = this.actions
    const { electricityConsumptionsRegistration } = this.props.values

    values = this.consumptionDisaggregationLogic(values)

    const item = electricityConsumptionsRegistration[index]

    electricityConsumptionsRegistration[index] = { ...item, ...values }

    setValues({ electricityConsumptionsRegistration })
  }

  /**
   * Removes an element from the table list of electricity
   */
  onRemoveElectricityValue = (index) => {
    const { setValues } = this.actions
    let { electricityConsumptionsRegistration } = this.props.values

    let clone = [...electricityConsumptionsRegistration]

    if (clone.length > 1) {
      clone.splice(index, 1)
    }

    setValues({ electricityConsumptionsRegistration: clone })
  }

  /**
   * Adds new eletricity table value to state
   */
  addNewElectricityTableValue = () => {
    const { setValues } = this.actions
    let { electricityConsumptionsRegistration } = this.props.values
    if (electricityConsumptionsRegistration.length >= MAX_LIST_ITEMS) {
      return false
    }

    electricityConsumptionsRegistration.push({
      startDate: null,
      endDate: null,
      simples: '',
      svazio: '',
      cheias: '',
      ponta: '',
    })

    setValues({ electricityConsumptionsRegistration })
  }

  /**
   * Sets the value of the gas element by index
   */
  setTableGasValues = (values, index) => {
    const { setValues } = this.actions
    const { gasConsumptionsRegistration } = this.props.values

    const item = gasConsumptionsRegistration[index]

    gasConsumptionsRegistration[index] = { ...item, ...values }

    setValues({ gasConsumptionsRegistration })
  }

  /**
   * Removes an element from the table list of gas
   */
  onRemoveGasValue = (index) => {
    const { setValues } = this.actions
    let { gasConsumptionsRegistration } = this.props.values

    if (gasConsumptionsRegistration.length > 1) {
      gasConsumptionsRegistration.splice(index, 1)
    }

    setValues({ gasConsumptionsRegistration })
  }

  /**
   * Adds a new gas table value to state
   */
  addNewGasTableValue = () => {
    const { setValues } = this.actions
    let { gasConsumptionsRegistration } = this.props.values

    if (gasConsumptionsRegistration.length >= MAX_LIST_ITEMS) {
      return false
    }

    gasConsumptionsRegistration.push({
      startDate: null,
      endDate: null,
      consumption: '',
    })

    setValues({ gasConsumptionsRegistration })
  }

  render() {
    const { setValues } = this.actions

    const {
      loading,
      hiredPowerSugested,
      offerType,
      invalid,
      translations,
      iframed,
    } = this.props

    const {
      GAS_SCALE,
      BILLING_TYPE,
      ELECTRONIC_BILL,
      JOINT_BILLING,
      ADDITIONAL_SERVICES,
      ELECTRICITY_SUPPLIER,
      ELECTRICITY_RATE,
      GAS_SUPPLIER,
    } = this.pickTranslations(translations)

    const {
      invoicing_type,
      has_electronic_billing,
      ciclo_horario,
      ciclo_tarifa,
      electricity_entity,
      gas_entity,
      potencia_contratada,
      gas_stage,
      hide_additional,
      has_consumes,
    } = this.props.values

    // We need to permit this value to change
    let { has_joint_billing } = this.props.values

    let {
      electricityEntities,
      gasEntities,
      powerChoices,
      /* priceCycleChoices, */
      timeCycleChoices,
      allEntities,
    } = this.props.filters

    // Loading? Dont do anything
    if (loading) {
      return <Loading />
    }

    const gasScales = [
      {
        value: 1,
        label: 'Escalão 1',
      },
      {
        value: 2,
        label: 'Escalão 2',
      },
      {
        value: 3,
        label: 'Escalão 3',
      },
      {
        value: 4,
        label: 'Escalão 4',
      },
    ]

    // Used to show determinated sections based on offertype chosen
    const isGas = offerType && offerType.slug === GAS_OFFER_TYPE

    const isElectricity = offerType && offerType.slug === ELECTRICITY_OFFER_TYPE

    const isElectricityAndGas =
      offerType && offerType.slug === GAS_AND_ELECTRICITY_OFFER_TYPE

    // i think i did this in a hurry
    // Remove tetra hórario from the list
    // if (!isEnterprise) {
    //   timeCycleChoices && delete timeCycleChoices['tetra-horário']
    // }

    // Convert object to array to use in selects and other mappers
    timeCycleChoices = timeCycleChoices && mapObjectToarray(timeCycleChoices)
    /* priceCycleChoices = priceCycleChoices && mapObjectToarray(priceCycleChoices) */
    powerChoices = powerChoices && mapObjectToarray(powerChoices)

    electricityEntities =
      electricityEntities &&
      electricityEntities.map(({ hi_res_logo, designation, id, ...item }) => ({
        label: designation,
        value: id,
        icon: generateMediaUrl(hi_res_logo),
        ...item,
      }))

    gasEntities =
      gasEntities &&
      gasEntities.map(({ hi_res_logo, designation, id, ...item }) => ({
        label: designation,
        value: id,
        icon: generateMediaUrl(hi_res_logo),
        ...item,
      }))

    allEntities =
      allEntities &&
      allEntities.map(({ hi_res_logo, designation, id, ...item }) => ({
        label: designation,
        value: id,
        icon: generateMediaUrl(hi_res_logo),
        ...item,
      }))

    const showEletricSection =
      isElectricity || (isElectricityAndGas && !has_joint_billing)
    const showGasSection = isGas || (isElectricityAndGas && !has_joint_billing)
    const showBothSection = isElectricityAndGas && has_joint_billing

    // If is just one type has_joint_billing is false, because there's no set of invoices
    if (isElectricity || isGas) {
      if (has_joint_billing) {
        setValues({ has_joint_billing: false })
      }
    }

    // Pick needed invalids
    let gasEntityInvalid = pickOrNot(invalid, ['gas_entity'])
    let electricityEntityInvalid = pickOrNot(invalid, ['electricity_entity'])
    let gasScaleInvalid = pickOrNot(invalid, ['gas_stage'])
    let hiredPowerInvalid = pickOrNot(invalid, ['potencia_contratada'])

    // Sets the value of ciclo de tarifa to diario if changed to Simple
    // https://gitlab.ubiwhere.com/adene-poupa-energia/adene-simulador-avancado/issues/7
    const SIMPLE_VALUE = 's'
    const DAILY_VALUE = 'd'
    if (ciclo_horario === SIMPLE_VALUE && ciclo_tarifa !== DAILY_VALUE) {
      setValues({ ciclo_tarifa: DAILY_VALUE })
    }

    const { consumptionDisaggregations } = this.props.filters

    // If ciclo_horario selected in faturation is BI horario cannot let
    // select a simple disaggregation
    // https://gitlab.ubiwhere.com/adene-poupa-energia/adene-simulador-avancado/issues/25
    let filteredConsumptionDisaggregations
    const BI_HORARY = 'b'
    const SIMPLE_ID = 's'
    const ENTERPRISE_ID = 'vscp'

    if (ciclo_horario === BI_HORARY) {
      filteredConsumptionDisaggregations = consumptionDisaggregations.filter(
        (item) => {
          return item.id !== SIMPLE_ID
        }
      )
    }
    if (!isEnterprise) {
      if (!filteredConsumptionDisaggregations) {
        filteredConsumptionDisaggregations = consumptionDisaggregations.filter(
          (item) => {
            return item.id !== ENTERPRISE_ID
          }
        )
      } else {
        filteredConsumptionDisaggregations = filteredConsumptionDisaggregations.filter(
          (item) => {
            return item.id !== ENTERPRISE_ID
          }
        )
      }
    }
    return (
      <Wrapper>
        {this.renderNavbar()}
        <FixedWrapper>
          <Section
            title={`Faturação`}
            subtitle={`Selecione o método de pagamento`}
            compact={iframed}>
            {BILLING_TYPE && <Tip data-slot='tip' text={BILLING_TYPE} />}
            {paymentMethods && (
              <RadioGroup
                items={paymentMethods}
                value={invoicing_type}
                name='payment_method'
                onSelectionChange={({ value }) =>
                  setValues({ invoicing_type: value })
                }
              />
            )}
          </Section>

          <Section
            title={`Fatura Eletrónica`}
            subtitle={`Recebe a sua fatura por via eletrónica`}
            grey
            compact={iframed}>
            {ELECTRONIC_BILL && <Tip data-slot='tip' text={ELECTRONIC_BILL} />}
            <ButtonConfirm
              onButtonClick={({ value }) =>
                setValues({ has_electronic_billing: value })
              }
              value={has_electronic_billing || false}
              items={BOOLEAN_CHOICES}
            />
          </Section>

          {isElectricityAndGas && (
            <Section
              title={`Fatura Conjunta?`}
              subtitle={`Possui os seus serviços agregados numa única fatura?`}
              compact={iframed}>
              {JOINT_BILLING && <Tip data-slot='tip' text={JOINT_BILLING} />}
              <ButtonConfirm
                onButtonClick={({ value }) =>
                  setValues({ has_joint_billing: value })
                }
                value={has_joint_billing || false}
                items={BOOLEAN_CHOICES}
                compact={iframed}
              />
            </Section>
          )}

          <Section
            title={`SERVIÇOS ADICIONAIS`}
            subtitle={`Ver tarifários com serviços adicionais?`}
            compact={iframed}>
            {ADDITIONAL_SERVICES && (
              <Tip data-slot='tip' text={ADDITIONAL_SERVICES} />
            )}
            <ButtonConfirm
              onButtonClick={({ value }) =>
                setValues({ hide_additional: value })
              }
              value={hide_additional || false}
              items={BOOLEAN_CHOICES}
            />
          </Section>

          {showEletricSection && (
            <Section
              title={`Comercializador Eletricidade`}
              subtitle={`Selecione o seu comercializador de Eletricidade`}
              id={`comerel`}
              className={electricityEntityInvalid && `invalid`}
              compact={iframed}>
              {ELECTRICITY_SUPPLIER && (
                <Tip data-slot='tip' text={ELECTRICITY_SUPPLIER} />
              )}
              <WrapperSelect>
                <LocationLabel>Comercializador de eletricidade</LocationLabel>
                <StyledSelect
                  margin
                  placeholder={`Comercializador de eletricidade`}
                  items={electricityEntities}
                  onChange={({ value }) =>
                    setValues({ electricity_entity: value })
                  }
                  selected={electricity_entity}
                  arrowIcon={ArrowIcon}
                />
              </WrapperSelect>
              {this.renderInvalidMessage(
                electricityEntityInvalid,
                'electricity_entity',
                'Comercializador'
              )}
            </Section>
          )}

          {showBothSection && (
            <Section
              title={`Comercializador Eletricidade e Gás`}
              subtitle={`Selecione o seu comercializador de Eletricidade e Gás`}
              id={`comerelg`}
              className={electricityEntityInvalid && `invalid`}
              compact={iframed}>
              <WrapperSelect>
                <LocationLabel>
                  Comercializador de eletricidade e gás
                </LocationLabel>
                <StyledSelect
                  margin
                  placeholder={`Comercializador de eletricidade e gás`}
                  items={allEntities}
                  onChange={({ value }) =>
                    setValues({ electricity_entity: value, gas_entity: value })
                  }
                  selected={electricity_entity}
                  arrowIcon={ArrowIcon}
                />
                {this.renderInvalidMessage(
                  electricityEntityInvalid,
                  'electricity_entity',
                  'Comercializador'
                )}
              </WrapperSelect>
            </Section>
          )}

          {(isElectricity || isElectricityAndGas) && (
            <Section
              title={`Tarifa de Eletricidade`}
              subtitle={`Selecione o seu tipo da tarifa de eletricidade`}
              grey
              compact={iframed}>
              {ELECTRICITY_RATE && (
                <Tip data-slot='tip' text={ELECTRICITY_RATE} />
              )}
              {timeCycleChoices && (
                <RadioGroup
                  items={timeCycleChoices}
                  value={ciclo_horario}
                  name='ciclo_horario'
                  onSelectionChange={({ value }) =>
                    setValues({ ciclo_horario: value })
                  }
                />
              )}
            </Section>
          )}

          {(isElectricity || isElectricityAndGas) && (
            <Section
              title={`Potência Contratada`}
              subtitle={`Selecione a potência contratada`}
              grey
              className={hiredPowerInvalid && `invalid`}
              compact={iframed}>
              <WrapperSelect>
                <LocationLabel>Potência Contratada</LocationLabel>
                <StyledSelect
                  margin
                  placeholder={`Potência Contratada`}
                  items={powerChoices}
                  onChange={({ value }) =>
                    setValues({ potencia_contratada: value })
                  }
                  selected={potencia_contratada}
                  arrowIcon={ArrowIcon}
                />
                {hiredPowerSugested && (
                  <AbsoluteToltip
                    text={`Com base nas suas respostas anteriores,a potência contratada deveria ser ${hiredPowerSugested} kVA`}
                    icon={Infoicon}
                  />
                )}
                {this.renderInvalidMessage(
                  hiredPowerInvalid,
                  'potencia_contratada',
                  'Potência Contratada'
                )}
              </WrapperSelect>
            </Section>
          )}

          {showGasSection && (
            <Section
              title={`Comercializador Gás Natural`}
              subtitle={`Selecione o seu comercializador de Gás Natural`}
              id={`comerg`}
              className={gasEntityInvalid && `invalid`}
              compact={iframed}>
              {GAS_SUPPLIER && <Tip data-slot='tip' text={GAS_SUPPLIER} />}
              <WrapperSelect>
                <LocationLabel>Comercializador Gás Natural</LocationLabel>
                <StyledSelect
                  margin
                  placeholder={`Comercializador Gás Natural`}
                  items={gasEntities}
                  onChange={({ value }) => setValues({ gas_entity: value })}
                  selected={gas_entity}
                  arrowIcon={ArrowIcon}
                />
                {this.renderInvalidMessage(
                  gasEntityInvalid,
                  'gas_entity',
                  'Comercializador'
                )}
              </WrapperSelect>
            </Section>
          )}

          {isSimple && (isGas || isElectricityAndGas) && (
            <Section
              title={`Escalão Gás Natural`}
              subtitle={`Selecione o seu escalão`}
              id={`comerg`}
              className={gasScaleInvalid && `invalid`}
              compact={iframed}>
              {GAS_SCALE && <Tip data-slot='tip' text={GAS_SCALE} />}
              <WrapperSelect>
                <LocationLabel>Escalão</LocationLabel>
                <StyledSelect
                  margin
                  placeholder={`Escalão`}
                  items={gasScales}
                  onChange={({ value }) => setValues({ gas_stage: value })}
                  selected={gas_stage}
                  arrowIcon={ArrowIcon}
                />
                {this.renderInvalidMessage(
                  gasScaleInvalid,
                  'gas_scale',
                  'Escalão'
                )}
              </WrapperSelect>
            </Section>
          )}

          {isSimple && (
            <Section
              title={`Deseja introduzir os seus consumos?`}
              subtitle={``}
              grey
              compact={iframed}>
              {timeCycleChoices && (
                <ButtonConfirm
                  onButtonClick={({ value }) => {
                    setValues({ has_consumes: value })
                    if (value === true) {
                      this.nextText = 'PRÓXIMO passo'
                    } else {
                      this.nextText = 'Simular'
                    }
                  }}
                  value={has_consumes || false}
                  items={BOOLEAN_CHOICES}
                  compact={iframed}
                />
              )}
            </Section>
          )}
        </FixedWrapper>

        {this.renderButtons()}
      </Wrapper>
    )
  }
}

const Wrapper = styled.div``

const WrapperSelect = styled.div`
  width: 310px;
  margin: 0 auto;
  margin-top: 30px;
  position: relative;

  @media (max-width: 1280px) {
    width: 320px;
  }
`

const StyledSelect = styled(Select)`
  width: 100%;
  max-width: initial;
  text-align: left;

  > div {
    border: 1px solid #bababa;
    color: #3e3e3e;
  }

  img {
    object-fit: scale-down;
  }
  ${({ margin }) => margin && `margin-right: 30px;`}
`

const LocationLabel = styled.label`
  text-align: left;
  padding-bottom: 5px;
  display: block;
  width: 100%;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 12px;
`

const AbsoluteToltip = styled(Toltip)`
  position: absolute;
  right: -115%;
  top: 42%;

  @media (max-width: 1280px) {
    right: 0;
    top: 115%;
  }
`
const Error = styled.span`
  display: inline-block;
  font-size: 12px;
  color: indianred;
  margin: 10px auto;
  text-align: left;
`



// WEBPACK FOOTER //
// ./src/containers/Faturation/index.js